export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
export const DATE_TIME_FORMAT_FOR_COLUMNS = 'HH:mm dd.MM.yyyy';
export const DATE_FORMAT_TO_DB = 'yyyy-MM-dd H:mm:ss.SSSS';
